import styled from 'styled-components';

const UnderlineSelected = styled.span`
  height: 20px;
  color: #000000;
  font-family: "Avenir", "Arial", sans-serif;
  font-size: 15px;
  font-weight: bold;
  ${({ selected }) => (selected ? 'border-bottom: 3px solid #000;' : null)}
  letter-spacing: 1px;
  line-height: 20px;
  text-transform: uppercase;
  cursor: pointer;
  text-decoration: none;
  padding: ${({ padding }) => padding};
  margin: ${({ margin }) => margin};
`;

export default UnderlineSelected;
